import React from 'react';
import PropTypes from 'prop-types';
import {PartnershipOverviewComponent} from '../../../common/CMS/components/PartnershipOverviewComponent';
import {requestHelpers} from "../../../../helpers";
import {PartnershipOverviewPlaceholderComponent} from "../../../common/placeholders/PartnershipOverviewPlaceholderComponent";
import {Heading} from "../../../common/CMS/elements";
import ThemePageBanner from "../../../dashboardNew/components/ThemePageBanner";
import Anchor from "../../../dashboardNew/objects/Anchor";

class PartnersCategoryPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            categories: null,
            initialLoad: true,
            isLoading: true
        };
    }

    componentWillMount() {
        this.makeRequest()
    }

    //Add these queries to request URl to sort by name ascending: orderby=title&order=asc
    makeRequest = (page) => {
        requestHelpers
            .getWordPressData(`https://blog.intouchnetworks.com/wp-json/wp/v2/pages/?slug=category-overview`)
            .then(response => {
                this.setState({
                    categories: response.data,
                    isLoading: false
                });
            });
    };


    render() {

        //Hacky way of displaying (via mapping through) 9 placeholder objects
        let placeholderArray = [1, 2, 3, 4, 5, 6, 7, 8, 9];

        return (
            <div className="container-fluid partners-page theme-page-content-wrapper">
                <ThemePageBanner image='/images/how-background.jpg' heading='Partnership Categories'/>
                <div className='container'>
                    <div className="row">
                        <div className="col-12 heading-section no-margin">
                            <p className="body-copy">Our partners are selected to cover an exhaustive realm of services
                                designed to best position you in reaching and surpassing your potential. From Financial
                                Services, Wealth Management and Equity Investment through to Executive Education, our
                                partners encompass the knowledge and services to progress your career and enhance your
                                business to align with your vision and goals. Utilise the services available from our
                                partners today.</p>
                        </div>
                        {this.state.categories && !this.state.isLoading && (
                            this.state.categories.map((category, i) => {
                                return (
                                    <PartnershipOverviewComponent
                                        description={category.short_description}
                                        header={category.title}
                                        primaryColor={category.primaryColor}
                                        buttonTextColor={category.primaryTextColor}
                                        secondaryColor={category.secondaryColor}
                                        logo={category.logo}
                                        button={category.button}
                                        link={`/partnerships/${category.title.replace(/\s/g, "-")}`}
                                        key={i}
                                        className='category'
                                    />
                                )
                            })
                        )}
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        {this.state.isLoading && (
                            placeholderArray.map((company, i) => {
                                return <PartnershipOverviewPlaceholderComponent key={i}/>
                            })
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default PartnersCategoryPage;

PartnersCategoryPage.propTypes = {
    categories: PropTypes.array,
    pagenation: PropTypes.object,

};



// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/PartnersCategoryPage.js